// Slide-over drawer containing the ConsultantChat. Driven by global
// open state in ConsultantContext so any component can open/close it.
// Uses the shadcn Sheet (which wraps Radix Dialog) — same primitive
// other slide-overs in the app use.

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
} from "@/components/ui/sheet";
import { useConsultant } from "@/contexts/ConsultantContext";
import { useSubscriptionTier } from "@/hooks/useSubscriptionTier";
import { canAccessTier } from "@/data/tierAccess";
import { ConsultantChat } from "./ConsultantChat";

// Same feature flag as ConsultantBubble. If the global kill switch is set,
// the drawer won't render even if somehow trigger()'d — belt and suspenders.
const CONSULTANT_ENABLED =
  (import.meta.env.VITE_CONSULTANT_ENABLED as string | undefined) !== "false";

export function ConsultantDrawer() {
  const { isOpen, close } = useConsultant();
  const { tier } = useSubscriptionTier();

  if (!CONSULTANT_ENABLED) return null;

  // Don't mount for non-Choice users — if they somehow triggered open()
  // we silently ignore. The bubble also doesn't render for them.
  if (!tier || !canAccessTier(tier, "choice")) return null;

  return (
    <Sheet open={isOpen} onOpenChange={(o) => !o && close()}>
      <SheetContent
        side="right"
        className="w-full sm:max-w-lg p-0 flex flex-col"
      >
        {/* Radix Dialog requires a Title + Description for a11y. Our visible
            header lives inside ConsultantChat, so these are screen-reader
            only — kills the "DialogContent requires a DialogTitle" console
            warning without introducing a duplicate visible header. */}
        <SheetTitle className="sr-only">RaisedBeef Cattle Consultant</SheetTitle>
        <SheetDescription className="sr-only">
          Ask questions about sale barns, fed cattle cash, boxed beef, and cohort pricing.
        </SheetDescription>
        <ConsultantChat />
      </SheetContent>
    </Sheet>
  );
}
